import { hooks } from "./hookactions"
export let SYSTranslation = { hooks }
